import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "openingTimeContainer",
    "openingStatus"
  ];

  connect() {
    if (this.openingStatusTarget.value == "open") {
      this.revealTimeSelectWhenOpen(this.openingTimeContainerTarget);
    }
  }

  handleTimeRangeTypeChange(status, element) {
    const toToggle = element ? element.closest(".nested-fields").querySelector(".schedules-timerange") : this.openingTimeContainerTarget;
    status == "open" ? toToggle.classList.remove("d-none") : toToggle.classList.add("d-none");
  }
}
